import netDialAPI from '@/util/call/neomecca/netDialAPI/netDialAPI';
import ktAPI from '@/util/call/kt/ktAPI/ktAPI';
import klcnsAPI from '@/util/call/klcns/klcnsAPI/klcnsAPI';
import neoWebRtcAPI from '@/util/call/neoWebRTC/neoWebRtcAPI/neoWebRtcAPI';

import cstaDefs from '@/util/call/neomecca/netDialAPI/cstaDefs';
import klcnsAgtStaDefs from '@/util/call/klcns/klcnsAPI/klcnsAgtStaDefs';
import cstaKtDefs from '@/util/call/kt/ktAPI/cstaKtDefs';
import neoWebRtcDefs from '@/util/call/neoWebRTC/neoWebRtcAPI/cstaDefs';

import { store } from '@/store/store';
import util from '@/util';
import logReport from '@/util/logReport';
import callChannelType from '@/constants/callChannelType';
import $http from '@/http';
import Helpers from '@/util/helpers';

function getLocalStorage() {
  return JSON.parse(localStorage.getItem('call-details-info'));
}

function getCallType() {
  const callType = util.getCallTypeFromToken();
  if (!callType) return callChannelType.NEOMECCA;
  return callType;
}

function getDefs() {
  switch (getCallType()) {
    case callChannelType.KT:
      return cstaKtDefs;
    case callChannelType.KLCNS:
      return klcnsAgtStaDefs;
    case callChannelType.NEO_WEB_RTC:
      return neoWebRtcDefs;
    case callChannelType.NEOMECCA:
    default:
      return cstaDefs;
  }
}

function getApi() {
  switch (getCallType()) {
    case callChannelType.KT:
      return ktAPI;
    case callChannelType.KLCNS:
      return klcnsAPI;
    case callChannelType.NEOMECCA:
      return netDialAPI;
    case callChannelType.NEO_WEB_RTC:
      return neoWebRtcAPI;
    default:
      console.error('타입 체크 에러');
  }
}

function execModule(func, args) {
  if (args) {
    getApi()[func](args);
  } else {
    getApi()[func]();
  }
}
const common = {
  setLocalStorage: (callInfo) => {
    localStorage.setItem('call-details-info', JSON.stringify(callInfo));
  },
  /*****************************************************************************
   * FUNCTON NAME : w2api_button_state()
   * DESCRIPTION  : 상태에 따라서 버튼 활성화 값 변경
   * INPUT        :
   * OUTPUT       :
   *****************************************************************************/
  buttonState: (state) => {
    var login = false;
    var logout = false;
    var makeCall = false;
    var answer = false;
    var hold = false;
    var retrieve = false;
    var consult = false;
    var transfer = false;
    var conference = false;
    var reconnect = false;
    var notReady = false;
    var ready = false;
    var disconnect = false;
    var reserve = false;
    var sendMessage = false;
    if (state === getDefs().STATE_LOGOUT) {
      login = false;
      logout = true;
      makeCall = true;
      answer = true;
      hold = true;
      retrieve = true;
      consult = true;
      transfer = true;
      conference = true;
      reconnect = true;
      notReady = true;
      ready = true;
      disconnect = true;
      reserve = false;
      sendMessage = false;
    } else {
      if (state === getDefs().STATE_LOGIN) {
        login = true;
        logout = false;
        makeCall = false;
        answer = true;
        hold = true;
        retrieve = true;
        consult = true;
        transfer = true;
        conference = true;
        reconnect = true;
        notReady = false;
        ready = false;
        disconnect = true;
        reserve = false;
        sendMessage = false;
      } else if (state === getDefs().STATE_READY) {
        login = true;
        logout = false;
        makeCall = false;
        answer = true;
        hold = true;
        retrieve = true;
        consult = true;
        transfer = true;
        conference = true;
        reconnect = true;
        notReady = false;
        ready = true;
        disconnect = true;
        reserve = false;
        sendMessage = false;
      } else if (state === getDefs().STATE_NREADY) {
        login = true;
        logout = false;
        makeCall = false;
        answer = true;
        hold = true;
        retrieve = true;
        consult = true;
        transfer = true;
        conference = true;
        reconnect = true;
        notReady = false;
        ready = false;
        disconnect = true;
        reserve = false;
        sendMessage = false;
      } else if (state === getDefs().STATE_DELIVERED_RECV) {
        login = true;
        logout = false;
        makeCall = true;
        answer = false;
        hold = true;
        retrieve = true;
        consult = true;
        transfer = true;
        conference = true;
        reconnect = true;
        notReady = true;
        ready = true;
        disconnect = true;
        reserve = true;
        sendMessage = false;
      } else if (state === getDefs().STATE_DELIVERED_SEND) {
        login = true;
        logout = false;
        makeCall = true;
        answer = true;
        hold = true;
        retrieve = true;
        consult = true;
        transfer = true;
        conference = true;
        reconnect = true;
        notReady = true;
        ready = true;
        disconnect = false;
        reserve = false;
        sendMessage = false;
      } else if (state === getDefs().STATE_DELIVERED_CONSULT) {
        login = true;
        logout = false;
        makeCall = true;
        answer = true;
        hold = true;
        retrieve = true;
        consult = true;
        transfer = true;
        conference = true;
        reconnect = false;
        notReady = true;
        ready = true;
        disconnect = false;
        reserve = false;
        sendMessage = false;
      } else if (state === getDefs().STATE_ESTABLISHED) {
        login = true;
        logout = false;
        makeCall = true;
        answer = true;
        hold = false;
        retrieve = true;
        consult = false;
        transfer = true;
        conference = true;
        reconnect = true;
        notReady = true;
        ready = true;
        disconnect = false;
        reserve = false;
        sendMessage = false;
      } else if (state === getDefs().STATE_ESTABLISHED_CONSULT) {
        login = true;
        logout = false;
        makeCall = true;
        answer = true;
        hold = true;
        retrieve = true;
        consult = true;
        transfer = false;
        conference = false;
        reconnect = false;
        notReady = true;
        ready = true;
        disconnect = false;
        reserve = false;
        sendMessage = false;
      } else if (state === getDefs().STATE_HOLD) {
        login = true;
        logout = false;
        makeCall = true;
        answer = true;
        hold = true;
        retrieve = false;
        consult = true;
        transfer = true;
        conference = true;
        reconnect = true;
        notReady = true;
        ready = true;
        disconnect = true;
        reserve = false;
        sendMessage = false;
      } else if (state === getDefs().STATE_CONFERENCED) {
        // 3자통화
        login = true;
        logout = false;
        makeCall = true;
        answer = true;
        hold = true;
        retrieve = true;
        consult = true;
        transfer = true;
        conference = true;
        reconnect = true;
        notReady = true;
        ready = true;
        disconnect = false;
        reserve = false;
        sendMessage = true;
      } else if (state === getDefs().STATE_SERVICE_INITIATED) {
        login = true;
        logout = false;
        makeCall = true;
        answer = true;
        hold = true;
        retrieve = true;
        consult = true;
        transfer = true;
        conference = true;
        reconnect = true;
        notReady = true;
        ready = true;
        disconnect = false;
        reserve = false;
        sendMessage = false;
      } else if (state === getDefs().STATE_ORIGINATED_COUNT1) {
        login = true;
        logout = false;
        makeCall = true;
        answer = true;
        hold = true;
        retrieve = true;
        consult = true;
        transfer = true;
        conference = true;
        reconnect = true;
        notReady = true;
        ready = true;
        disconnect = false;
        reserve = true;
        sendMessage = false;
      } else if (state === getDefs().STATE_ORIGINATED_COUNT2) {
        login = true;
        logout = false;
        makeCall = true;
        answer = true;
        hold = true;
        retrieve = true;
        consult = true;
        transfer = true;
        conference = true;
        reconnect = false;
        notReady = true;
        ready = true;
        disconnect = false;
        reserve = false;
        sendMessage = false;
      }
    }

    // 사용자 버튼 제어
    if (state !== getDefs().STATE_LOGOUT) {
      store.commit('changeBtnStatus', {
        logout,
        login,
        ready,
        notReady,
        hold,
        retrieve,
        consult,
        transfer,
        conference,
        reconnect,
        makeCall,
        answer,
        disconnect,
        reserve,
        sendMessage
      });
    }
  },
  setAgentState: (agentMode, callLoginId, subStatus) => {
    switch (getCallType()) {
      case callChannelType.KT:
        ktAPI.ktAgentStatus(cstaKtDefs.AgentMode[agentMode] || agentMode, subStatus);
        break;
      case callChannelType.KLCNS:
        klcnsAPI.klcnsSetAgentStatus(klcnsAgtStaDefs.AgentMode[agentMode] || agentMode, subStatus);
        break;
      case callChannelType.NEOMECCA:
        netDialAPI.ndSetAgentState(cstaDefs.AgentMode[agentMode] || agentMode, callLoginId, '', '', subStatus || '');
        break;
      case callChannelType.NEO_WEB_RTC:
        neoWebRtcAPI.ndSetAgentState(neoWebRtcDefs.AgentMode[agentMode] || agentMode, callLoginId, '', '', subStatus || '');
    }
  },
  removeLocalStorage: () => {
    if (getCallType() === callChannelType.NEOMECCA) {
      netDialAPI.initIsLogin();
    } else if (getCallType() === callChannelType.NEO_WEB_RTC) {
      neoWebRtcAPI.initIsLogin();
    }
    localStorage.removeItem('call-details-info');
  }
};
const apiEvent = {
  /*****************************************************************************
   * FUNCTON NAME : EventProc()
   * DESCRIPTION  : CTI Server에서 수신한 이벤트 구조체 처리.
   * INPUT        : CTI Server에서 수신한 이벤트 구조체
   * OUTPUT       : P_API 구조체
   /*****************************************************************************/
  EventProc: (rcvData) => {
    execModule('EventProc', rcvData);
  },
  startMonitor: (telNumber) => {
    store.commit('changeIsCallConnecting', false);
    const callDetailsInfo = getLocalStorage();
    if (callDetailsInfo) {
      getApi().setCallInfo(callDetailsInfo);
    }

    switch (getCallType()) {
      case callChannelType.KT:
        ktAPI.ktStartMonitor();
        break;
      case callChannelType.KLCNS:
        klcnsAPI.klcnsStartMonitor();
        break;
      case callChannelType.NEOMECCA:
        if (!callDetailsInfo) {
          netDialAPI.initCallID();
        }
        if (telNumber) netDialAPI.ndMonitorDevice(telNumber, 0, 0, 0, 0, 0, '0');
        break;
      case callChannelType.NEO_WEB_RTC:
        if (!callDetailsInfo) {
          neoWebRtcAPI.initCallID();
        }
        if (telNumber) neoWebRtcAPI.ndMonitorDevice(telNumber, 0, 0, 0, 0, 0, '0');
    }
  },
  fetchAgentList: () => {
    if (getCallType() === callChannelType.NEOMECCA) netDialAPI.ndGetGroupAgentList('99999', '*', '*', '*', '*');
    if (getCallType() === callChannelType.NEO_WEB_RTC) getAgentList();
  },
  loginCall: (callLoginId) => {
    switch (getCallType()) {
      case callChannelType.KT:
        loginKt(callLoginId);
        break;
      case callChannelType.KLCNS:
        loginKlcns(callLoginId);
        break;
      case callChannelType.NEOMECCA:
        loginNeomecca(callLoginId);
        break;
      case callChannelType.NEO_WEB_RTC:
        loginNeoWebRTC(callLoginId);
        break;
    }
  },
  getSelfMonitor: () => {
    if (getCallType() === callChannelType.NEOMECCA) netDialAPI.ndGetCenterStatus();
    // if (getCallType() === callChannelType.NEO_WEB_RTC) getAgentStatus();
  },
  makeCall: (number, reception) => {
    switch (getCallType()) {
      case callChannelType.KT:
        ktAPI.ktExternalCall(number.slice(1), reception);
        break;
      case callChannelType.KLCNS:
        klcnsAPI.klcnsOriginate(number.slice(1), reception);
        break;
      case callChannelType.NEOMECCA:
        netDialAPI.ndMakeCall(number, reception, reception.length);
        break;
      case callChannelType.NEO_WEB_RTC:
        neoWebRtcAPI.ndMakeCall(number, reception, reception.length);
    }
  },
  answerCall: () => {
    switch (getCallType()) {
      case callChannelType.KT:
        ktAPI.ktAnswer();
        break;
      case callChannelType.KLCNS:
        klcnsAPI.klcnsAnswer();
        break;
      case callChannelType.NEOMECCA:
        netDialAPI.ndAnswerCall();
        break;
      case callChannelType.NEO_WEB_RTC:
        neoWebRtcAPI.ndAnswerCall();
        break;
    }
  },
  holdCall: () => {
    switch (getCallType()) {
      case callChannelType.KT:
        ktAPI.ktHold(true);
        break;
      case callChannelType.KLCNS:
        klcnsAPI.klcnsHoldAudio(true);
        break;
      case callChannelType.NEOMECCA:
        netDialAPI.ndHoldCall();
        break;
      case callChannelType.NEO_WEB_RTC:
        neoWebRtcAPI.ndHoldCall();
    }
  },
  closeCall: (callLoginId) => {
    common.setAgentState('AM_LOG_OUT', callLoginId);
  },
  holdCancel: () => {
    switch (getCallType()) {
      case callChannelType.KT:
        ktAPI.ktHold(false);
        break;
      case callChannelType.KLCNS:
        klcnsAPI.klcnsHoldAudio(false);
        break;
      case callChannelType.NEOMECCA:
        netDialAPI.ndRetrieveCall();
        break;
      case callChannelType.NEO_WEB_RTC:
        neoWebRtcAPI.ndRetrieveCall();
        break;
    }
  },
  endCall: () => {
    switch (getCallType()) {
      case callChannelType.KT:
        ktAPI.ktHangup();
        break;
      case callChannelType.KLCNS:
        klcnsAPI.klcnsHangUp();
        break;
      case callChannelType.NEOMECCA:
        netDialAPI.ndClearConnection();
        break;
      case callChannelType.NEO_WEB_RTC:
        neoWebRtcAPI.ndClearConnection();
        break;
    }
  },
  transferCancel: () => {
    if (getCallType() === callChannelType.KT) ktAPI.ktTransferCancel();
    if (getCallType() === callChannelType.KLCNS) klcnsAPI.klcnsTransferCancel();
  },
  reConnectCall: () => {
    if (getCallType() === callChannelType.NEOMECCA) netDialAPI.ndReconnectCall();
    if (getCallType() === callChannelType.NEO_WEB_RTC) neoWebRtcAPI.ndReconnectCall();
  },
  transferCall: () => {
    if (getCallType() === callChannelType.NEOMECCA) netDialAPI.ndTransferCall();
    if (getCallType() === callChannelType.NEO_WEB_RTC) neoWebRtcAPI.ndTransferCall();
  },
  consultationCall: (telNumber, userInfo, len) => {
    if (getCallType() === callChannelType.KT) ktAPI.ktTransfer('a', telNumber);
    if (getCallType() === callChannelType.KLCNS) klcnsAPI.klcnsTransfer(telNumber);
    if (getCallType() === callChannelType.NEOMECCA) netDialAPI.ndConsultationCall(telNumber, userInfo, len);
    if (getCallType() === callChannelType.NEO_WEB_RTC) neoWebRtcAPI.ndConsultationCall(telNumber, userInfo, len);
  },
  conferenceCall: () => {
    if (getCallType() === callChannelType.NEOMECCA) netDialAPI.ndConferenceCall();
    if (getCallType() === callChannelType.NEO_WEB_RTC) neoWebRtcAPI.ndConferenceCall();
  },
  spyCall: (extension, option) => {
    if (getCallType() === callChannelType.KT) ktAPI.ktSpyCall(extension, option);
    if (getCallType() === callChannelType.KLCNS) klcnsAPI.klcnsSpyCall(extension, option);
  },
  getNeoRtcAgentWorkData: () => {
    // 네오메카 webRTC 전용 상담사 개인 통계 조회 api
    const url = process.env.NEO_WEB_RTC_TRLINK;
    $http({
      method: 'GET',
      url: `${url}/TrLink/manager/link/fnGetAgtWorkData.do?agentId=${store.getters.callLoginId}`
    })
      .then((res) => {
        const obj = {
          totalTime: res.data.BUSY_TIME, // 총 통화
          averageTime: res.data.AVG_BUSY_TIME, // 평균통화
          waitTime: res.data.WAIT_TIME, // 상담대기
          summaryTime: res.data.SAVE_TIME, // 후처리
          maxCount: { inBound: res.data.MAX_IN_CNT, outBound: res.data.MAX_OUT_CNT }, // 전체콜
          averageCount: { inBound: res.data.AVG_IN_CNT, outBound: res.data.AVG_OUT_CNT }, // 평균콜
          myCount: { inBound: res.data.IN_CNT, outBound: res.data.OUT_CNT } // 본인콜
        };
        store.commit('setAgentStatistics', obj);
      })
      .catch((err) => {
        logReport.write(`[GET-NEO-RTC-AGENT-WORK-DATA] 조회 오류: ${err}`);
      });
  },
  getNeoRtcWaitingCount: () => {
    // 네오메카 webRTC 전용 대기중 고객 수 조회 api
    const url = process.env.NEO_WEB_RTC_TRLINK;
    $http({
      method: 'GET',
      url: `${url}/TrLink/manager/link/fnGetWaitCustCnt.do?agentId=${store.getters.callLoginId}`,
      NProgress: false
    })
      .then((res) => {
        store.commit('setWaitingCount', res.data.WAIT_CUST_CNT);
      })
      .catch((err) => {
        logReport.write(`[GET-NEO-RTC-WAITING-COUNT] 조회 오류: ${err}`);
      });
  }
};

function loginKt(callLoginId) {
  common.setAgentState('AM_LOG_IN');
  const status = store.getters.callAgentStatus;

  if (status) {
    switch (status) {
      case '대기':
        setTimeout(() => common.setAgentState('AM_READY'), 1000);
        break;
      case '통화중':
        try {
          const direction = JSON.parse(localStorage.getItem('call-info')).direction;
          if (direction === 'I' || direction === 'O') {
            setTimeout(() => common.setAgentState(direction === 'I' ? 'AM_INCALL' : 'AM_CALL'), 1000);
          }
        } catch (e) {
          console.log(e);
        }
        break;
      case '후처리중':
        setTimeout(() => common.setAgentState('AM_WORK_NOT_READY'), 1000);
        break;
    }
  } else {
    common.setAgentState('AM_LOG_IN', callLoginId);
    logReport.write(`[CHANGE-AGENT]상담준비`);
    store.commit('changeCallAgentStatus', '상담준비');
  }
}

function loginKlcns(callLoginId) {
  common.setAgentState('AM_LOG_IN');
  const status = store.getters.callAgentStatus;

  if (status) {
    switch (status) {
      case '대기':
        setTimeout(() => common.setAgentState('AM_READY'), 1000);
        break;
      case '통화중':
        try {
          const direction = JSON.parse(localStorage.getItem('call-info')).direction;
          if (direction === 'I' || direction === 'O') {
            setTimeout(() => common.setAgentState(direction === 'I' ? 'AM_INCALL' : 'AM_CALL'), 1000);
          }
        } catch (e) {
          console.log(e);
        }
        break;
      case '후처리중':
        setTimeout(() => common.setAgentState('AM_WORK_NOT_READY'), 1000);
        break;
    }
  } else {
    common.setAgentState('AM_LOG_IN', callLoginId);
    logReport.write(`[CHANGE-AGENT]상담준비`);
    store.commit('changeCallAgentStatus', '상담준비');
  }
}

function loginNeomecca(callLoginId) {
  common.setAgentState('AM_LOG_IN', callLoginId);
  const status = store.getters.callAgentStatus;

  if (status) {
    if (status === '대기') {
      common.setAgentState('AM_READY', callLoginId);
    } else if (status === '후처리중') {
      common.setAgentState('AM_WORK_NOT_READY', callLoginId);
    }
  } else {
    common.setAgentState('AM_NOT_READY', callLoginId, '09');
    logReport.write(`[CHANGE-AGENT]상담준비`);
    store.commit('changeCallAgentStatus', '상담준비');
  }

  netDialAPI.eventTimer();
}

function loginNeoWebRTC(callLoginId) {
  common.setAgentState('AM_LOG_IN', callLoginId);
  const status = store.getters.callAgentStatus;

  if (status) {
    if (status === '대기') {
      common.setAgentState('AM_READY', callLoginId);
    } else if (status === '후처리중') {
      common.setAgentState('AM_WORK_NOT_READY', callLoginId);
    }
  } else {
    common.setAgentState('AM_NOT_READY', callLoginId, '09');
    logReport.write(`[CHANGE-AGENT]상담준비`);
    store.commit('changeCallAgentStatus', '상담준비');
  }

  neoWebRtcAPI.eventTimer();
}

function getAgentList() {
  // 네오메카 webRTC 전용 '상담중 상담사' 목록 조회 api
  const url = process.env.NEO_WEB_RTC_TRLINK;
  const ctiAgentGroup = store.getters.ctiAgentGroup;
  $http({
    method: 'GET',
    url: `${url}/TrLink/manager/link/fnGetAgtStateList.do?group=${ctiAgentGroup}`,
    NProgress: false
  })
    .then((res) => {
      const agentList = Helpers.parseNeoWebRtcAgentStatus(res.data);
      store.commit('changeCallAgentList', agentList);
    })
    .catch(() => {
      logReport.write('[GET-AGENT-LIST] 상담사 목록 조회 API 오류');
      store.commit('changeCallAgentList', []);
    });
}

// webRtc 모니터링 상태 체크용으로 사용하려 했으나, 필요 없어져서 미사용
// function getAgentStatus() {
//   // 네오메카 webRTC 전용 상담사 상태 체크용 api
//   const url = process.env.NEO_WEB_RTC_TRLINK;
//   const agentId = store.getters.callLoginId;
//   $http({
//     url: `${url}/TrLink/manager/link/fnGetAgtState.do?agentId=${agentId}`,
//     method: 'GET',
//     NProgress: false,
//     timeout: 5000
//   })
//     .then((res) => {
//       if (res.status === 200) {
//         store.commit('resetStopCount');
//         store.commit('REMOVE_TOASTED_INFO');
//         store.commit('setIsOverlap', false);
//         store.commit('initDimmed');
//       } else {
//         logReport.write('[FN-GET-AGT-STATE] 상담사 상태 조회 API 오류');
//         store.commit('addStopCount');
//       }
//     })
//     .catch(() => {
//       logReport.write('[FN-GET-AGT-STATE] 상담사 상태 조회 API 오류 (catch)');
//       store.commit('addStopCount');
//     })
//     .finally(() => {
//       const { stopCnt, isIntervalCheck, IS_CALL_CONNECTED, enabledCallAgent, IS_OVER_LAP } = store.getters;
//       if (!isIntervalCheck) return;
//       if (stopCnt < 5) {
//         if (stopCnt > 2) {
//           store.commit('REMOVE_TOASTED_INFO');
//           store.commit('ADD_TOASTED_INFO', Vue.toasted.show(`콜 서버 응답 지연되고 있습니다.`));
//           logReport.write(`콜 서버 응답 지연... ${stopCnt * 5000}ms`);
//         }
//       } else {
//         if (!IS_OVER_LAP) {
//           store.commit('REMOVE_TOASTED_INFO');
//           store.commit('ADD_TOASTED_INFO', Vue.toasted.show(`콜 서버 응답 지연되고 있습니다.<br/>네트워크 상태를 확인해주세요.`));
//           store.commit('setIsOverlap', true);
//           store.commit('initDimmed');
//         }
//       }
//       setTimeout(() => {
//         if (IS_CALL_CONNECTED && enabledCallAgent && isIntervalCheck) {
//           apiEvent.getSelfMonitor();
//           apiEvent.getNeoRtcWaitingCount();
//         }
//       }, 5000);
//     });
// }

const eventList = util.mergeObject(common, apiEvent);
export default eventList;



// WEBPACK FOOTER //
// ./src/util/call/apiEvent.js